import React, { useState, useRef } from 'react';
import './SiteCard.css';

function SiteCard({ site, isAdmin, onDelete, onEdit, onDragStart, onDragOver, onDrop, onDragEnd, isDragging }) {
  const [isDraggable, setIsDraggable] = useState(false);
  const holdTimer = useRef(null);

  const handleClick = () => {
    if (!isDraggable) {
      window.open(site.url, '_blank');
    }
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(site.siteId || site.id);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(site);
  };

  const handleMouseDown = (e) => {
    if (!isAdmin) return;
    
    // Only start timer for left click and not on buttons
    if (e.button === 0 && !e.target.closest('.card-actions')) {
      holdTimer.current = setTimeout(() => {
        setIsDraggable(true);
      }, 500); // 0.5 seconds
    }
  };

  const handleMouseUp = () => {
    if (holdTimer.current) {
      clearTimeout(holdTimer.current);
      holdTimer.current = null;
    }
  };

  const handleMouseLeave = () => {
    if (holdTimer.current) {
      clearTimeout(holdTimer.current);
      holdTimer.current = null;
    }
  };

  const handleDragStartInternal = (e) => {
    if (isAdmin && isDraggable) {
      e.stopPropagation();
      onDragStart(site);
    } else {
      e.preventDefault();
    }
  };

  const handleDragEndInternal = () => {
    if (isAdmin) {
      setIsDraggable(false);
      onDragEnd();
    }
    if (holdTimer.current) {
      clearTimeout(holdTimer.current);
      holdTimer.current = null;
    }
  };

  return (
    <div 
      className={`site-card ${isDragging ? 'dragging' : ''} ${isDraggable ? 'drag-ready' : ''}`}
      onClick={handleClick}
      draggable={isDraggable}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onDragStart={handleDragStartInternal}
      onDragOver={(e) => {
        if (isAdmin) {
          onDragOver(e);
        }
      }}
      onDrop={(e) => {
        if (isAdmin) {
          e.stopPropagation();
          onDrop(site);
        }
      }}
      onDragEnd={handleDragEndInternal}
      style={{ cursor: isAdmin ? (isDraggable ? 'grabbing' : 'pointer') : 'pointer' }}
    >
      {isAdmin && (
        <div className="card-actions">
          <button className="edit-button" onClick={handleEdit} title="Edit site">
            ✎
          </button>
          <button className="delete-button" onClick={handleDelete} title="Remove site">
            ×
          </button>
        </div>
      )}
      <div className="site-icon">
        {site.icon === 'placeholder' ? (
          <div className="placeholder-icon">{site.name.charAt(0)}</div>
        ) : (
          <img src={site.icon} alt={site.name} />
        )}
      </div>
      <div className="site-name">{site.name}</div>
    </div>
  );
}

export default SiteCard;
